import Register from './Register'
import { UserIsNotRegistered, siteTitle } from '../'
import TermsPage from './Terms'

const RegisterRoutes = {
		register: {
				path: '/Register',
				label: 'Register',
				title: `${siteTitle} - Register`,
				component: UserIsNotRegistered(Register)
		}
}

const TermsRoutes = {
		terms: {
				path: '/Terms',
				label: 'Terms',
				title: `${siteTitle} - Terms & Conditions`,
				component: TermsPage
		}
}

export { RegisterRoutes, Register, TermsRoutes, TermsPage }



// WEBPACK FOOTER //
// ./src/app/containers/Register/index.ts